import { Component } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { Logger } from '@clickd-angular/common-lib';

@Component({
  selector: 'com-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'commerce';

  constructor(private router: Router, private logger: Logger) {
    // Eyal: I'm leaving this so we can use this during debug to log what the router
    // router.events.subscribe((routerEvent) => {
    //   if (routerEvent instanceof NavigationStart ) {
    //     this.logger.log('navigating');
    //   }
    //   this.logger.log(routerEvent);
    // });

    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        if (!!event.url && event.url.match(/^\/#/)) {
          const url = event.url.replace('/#', '');
          this.router.navigateByUrl(url);
        }
      }
    });
  }
}
